import baseShadow from './base-shadow'

const createShadow = (options = {}) => {
  return baseShadow
}

export { createShadow }
